import { Form } from 'react-bootstrap';
import { useState } from 'react';

interface CheckboxProps {
  checked: boolean;
}

const DisabledCheckbox: React.FC<CheckboxProps> = ({ checked }) => {
  return (
    <Form.Check
      type="checkbox"
      checked={checked}
      className="border-dark"
      disabled
    />
  );
};

export default DisabledCheckbox;
